module.exports = __webpack_public_path__ + "img/selectTab3.8cd3dffa.png";